import { stats, trustItems } from "@/mocks/stats";

export default function TrustSection() {
  return (
    <section className="py-16 md:py-24 bg-secondary-50" aria-labelledby="trust-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Top label */}
        <span className="inline-block px-3 py-1 rounded-full bg-secondary-200/60 text-secondary-700 text-xs font-medium">
          Why Trust Us
        </span>

        <div className="mt-8 flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Mission */}
          <div className="lg:w-[45%]">
            <h2 id="trust-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              Reviewed by experienced spreadsheet users and verified by a community of real buyers.
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              Our guides are continuously updated based on community feedback, seller reliability data, and product quality trends. Every recommendation in the KakobuySpreadsheet is backed by actual transaction history and verified buyer experiences.
            </p>
          </div>

          {/* Right: Stats Grid */}
          <div className="lg:w-[55%]">
            <div className="grid grid-cols-2 gap-6 md:gap-10">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-foreground-500 text-xs md:text-sm">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Trust Items Grid */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {trustItems.map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="mt-4 font-semibold text-foreground-900 text-sm md:text-base">
                {item.title}
              </h3>
              <p className="mt-2 text-foreground-500 text-xs md:text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}